import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import UserService from "../../Services/UserList";
import Swal from "sweetalert2";
import MainLayout from "./MainLayout";
import Loader from "../utils/Loader";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  TablePagination,
  TextField,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  TableSortLabel,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Select as MuiSelect } from "@mui/material";
import Select from "react-select";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { BlockOutlined, Label, Search } from "@mui/icons-material";
import Apiurl from "../../Helpers/apiUrl";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import TableChartIcon from "@mui/icons-material/TableChart";
import { fetchAdminProduct } from "../../redux/slices/productSlice";
import { TableBodySkeleton } from "../utils/TableSkeleton";
import { add } from "dexie";
import BulkUploadProduct from "./BulkUploadProduct";
import FilterBar2 from "./admin_dashboard/FilterBar2";
import { Plus, PlusCircle } from "lucide-react";

export default function AdminProduct() {
  const dispatch = useDispatch();
  const { state } = useLocation();

  const [products, setProducts] = useState([]);
  const [group, setGroup] = useState([]);
  const [collection, setCollection] = useState([]);
  const [spare, setSpare] = useState([]);
  const [finish, setFinish] = useState([]);
  const [segmentOpt, setSegmentOpt] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [collectionData, setCollectionData] = useState([]);
  const [spareData, setSpareData] = useState([]);
  const [segmentData, setSegmentData] = useState([]);
  const [finsihData, setFinishData] = useState([]);
  const [preferencesData, setPreferenceData] = useState("");
  const [newPreferenceData, setNewPreferenceData] = useState("");
  const [searchQuery, setSearchQuery] = useState(state && state?.search || "");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editedProduct, setEditedProduct] = useState({});
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productImage, setProductImage] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [selectedFinish, setSelectedFinish] = useState([]);
  const [selectedSpare, setSelectedSpare] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [selectedCollection, setSelectedCollection] = useState([]);
  const [selectedSegment, setSelectedSegment] = useState([]);
  const [selectedPreference,setSelectedPreference]=useState([]);
  const [linediagram_imageImage, setLineDiagramImage] = useState(null);
  const [newLineDiagramImage, setNewLineDiagramImage] = useState(null);

  const [openAddModal, setOpenAddModal] = useState(false);
  const [newProduct, setNewProduct] = useState({});
  const [newProductImage, setNewProductImage] = useState(null);
  const [addErrorMessage, setAddErrorMessage] = useState("");
  const [newSpareData, setNewSpareData] = useState("");
  const [newSegmentData, setNewSegmentData] = useState("");
  const [newGroupData, setNewGroupData] = useState("");
  const [newCollectionData, setNewCollectionData] = useState("");
  const [newFinishData, setNewFinishData] = useState("");

  const { adminProducts, count, getStatus } = useSelector(
    (state) => state.product
  );
  const counts = count || 0;

  const brandOpt = [
    { value: "GROHE", label: "GROHE" },
    { value: "AS", label: "AMERICAN STANDARD" },
  ];

  const preferencesOpt = [
    { value: "Prior", label: "Prior" },
    { value: "Non-Prior", label: "Non-Prior" },
  ];

  const [sortBy, setSortBy] = useState({
    sort_by: "",
    order: "desc",
  });

  const fallbackImg = Apiurl ? Apiurl.replace('/api/', '/img/no_image.jpeg') : '/img/no_image.jpeg';

  const getProductImageSrc = (img, updatedAt) => {
    if (!img) return fallbackImg;
    if (typeof img === "string") {
      if (img.startsWith("data:")) return img;
      if (img.startsWith("http://") || img.startsWith("https://")) {
        return updatedAt ? `${img}?v=${updatedAt}` : img;
      }
      const backendBase = Apiurl.replace('/api/', '');
      const cleanPath = img.startsWith('/') ? img : `/${img}`;
      const fullUrl = `${backendBase}${cleanPath}`;
      return updatedAt ? `${fullUrl}?v=${updatedAt}` : fullUrl;
    }
    if (img instanceof File || img instanceof Blob) {
      return URL.createObjectURL(img);
    }
    return fallbackImg;
  };

  useEffect(() => {
    dispatch(
      fetchAdminProduct({
        page: page,
        rowsPerPage: rowsPerPage,
        search: searchQuery,
        sort_by: sortBy.sort_by,
        sort_order: sortBy.order,
        brand: selectedBrand?.length > 0 ? selectedBrand.map((i) => i.value).join(',') : "",
        finish: selectedFinish?.length > 0 ? selectedFinish.map((i) => i.value).join(',') : "",
        spare_fg: selectedSpare?.length > 0 ? selectedSpare.map((i) => i.value).join(',') : "",
        product_typ_group: selectedGroup?.length > 0 ? selectedGroup.map((i) => i.value).join(',') : "",
        collection: selectedCollection?.length > 0 ? selectedCollection.map((i) => i.value).join(',') : "",
        preferences: selectedPreference?.length > 0 ? selectedPreference.map((i) => i.value).join(',') : "",
        priceSegment: selectedSegment?.length > 0 ? selectedSegment.map((i) => i.value).join(',') : "",
      })
    );
  }, [
    page,
    rowsPerPage,
    searchQuery,
    sortBy,
    selectedBrand,
    selectedFinish,
    selectedSpare,
    selectedGroup,
    selectedCollection,
    selectedPreference,
    selectedSegment,
    dispatch,
  ]);

  useEffect(() => {
    productSpareApi();
    productGrouptApi();
    productCollectionApi();
    productFinsiApi();
    productSegmentApi();
  }, []);

  // group
  const productGrouptApi = async () => {
    try {
      const response = await UserService.group();
      if (response && response.data) {
        setGroup(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch product groups:", error);
    }
  };

  const productCollectionApi = async () => {
    try {
      const response = await UserService.collection();
      if (response && response.data) {
        setCollection(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch product collections:", error);
    }
  };

  // spare
  const productSpareApi = async () => {
    try {
      const response = await UserService.spare();
      if (response && response.data) {
        setSpare(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch product spares:", error);
    }
  };

  const productFinsiApi = async () => {
    try {
      const response = await UserService.finish();
      if (response && response.data) {
        setFinish(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch product finishes:", error);
    }
  };

  const productSegmentApi = async () => {
    try {
      const response = await UserService.segment();
      if (response && response.data) {
        setSegmentOpt(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch product segments:", error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDownloadExcel = () => {
    const filteredData = adminProducts?.map((product) => ({
      hsn_code: product.hsnCode,
      sku_code: product.sku_code,
      brand: product.brand,
      product_desc: product.product_desc,
      finish: product.finish,
      qty: product.qty,
      mrp: product.mrp,
      // disc_perc: product.disc_perc,
      // disc_price: product.disc_price,
      gst: product.gst,
      total: product.total,
      type: product.type,
      category: product.category,
      price_segment: product.priceSegment,
      spare_fg: product.spare_fg,
      product_typ_group: product.product_typ_group,
      collection: product.collection,
      preferences: product.preferences,
    }));
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "ProductList.xlsx"); // Save the Blob as an Excel file
  };

  const handleEditClick = (product) => {
    setSelectedProduct(product);
    setEditedProduct(product);
    setSpareData(product.spare_fg);
    setCollectionData(product.collection);
    setGroupData(product.product_typ_group);
    setFinishData(product.finish);
    setSegmentData(product.priceSegment);
    setPreferenceData(product.preferences || "");
    setOpenEditModal(true);
    setProductImage(product.image);
    setLineDiagramImage(product.linediagram_image || null);
  };
  const handleCloseEditModal = () => {
    setEditedProduct({});
    setOpenEditModal(false);
  };

  const handleEditChange = (event) => {
    const { name, value, files } = event.target;

    if (name === "image") {
      const file = files[0];
      const fileType = file?.type.split("/")[1]?.toLowerCase();
      if (file && (fileType === "jpeg" || fileType === "jpg")) {
        setErrorMessage("");
        // setImage(file);
      } else {
        setErrorMessage("Please upload a valid .jpg or .jpeg image.");
        return null;
      }
      setEditedProduct((prevState) => ({
        ...prevState,
        image: file,
      }));
      const imageUrl = URL.createObjectURL(file);
      setProductImage(file);
      // console.log(productImage);
    } else if (name === "linediagram_image") {
      const file = files[0];
      const fileType = file?.type.split("/")[1]?.toLowerCase();
      if (file && (fileType === "jpeg" || fileType === "jpg" || fileType === "png")) {
        setErrorMessage("");
        setEditedProduct((prevState) => ({
          ...prevState,
          linediagram_image: file,
        }));
        setLineDiagramImage(file);
      } else {
        setErrorMessage("Please upload a valid image file.");
      }
    } else {
      setEditedProduct({
        ...editedProduct,
        [name]: value,
      });
    }
  };

  const handleSaveEdit = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("id", editedProduct.id);
      formData.append("brand", editedProduct.brand);
      formData.append("sku_code", editedProduct.sku_code);
      formData.append("mrp", editedProduct.mrp);
      formData.append("gst", editedProduct.gst);
      formData.append("spare_fg", spareData);
      formData.append("product_group", groupData);
      formData.append("collection", collectionData);
      formData.append("product_desc", editedProduct.product_desc);
      formData.append("image", editedProduct.image);
      formData.append("linediagram_image", editedProduct.linediagram_image || "");
      formData.append("finish", editedProduct.finish);
      formData.append("hsnCode", editedProduct.hsnCode || "");
      formData.append("category", editedProduct.category || "");
      formData.append("price_segment", segmentData || "");
      formData.append("preferences", preferencesData || "");

      const token = localStorage.getItem("u_token");
      fetch(`${Apiurl}admin/product/update`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "*/*",
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.message) {
            setEditedProduct({});
            setLoading(false);
            dispatch(
              fetchAdminProduct({
                page: page,
                rowsPerPage: rowsPerPage,
                search: searchQuery,
                sort_by: sortBy.sort_by,
                sort_order: sortBy.order,
                brand: selectedBrand?.length > 0 ? selectedBrand?.map((i) => i.value) : null,
                finish: selectedFinish?.length > 0 ? selectedFinish?.map((i) => i.value) : null,
                spare_fg: selectedSpare?.length > 0 ? selectedSpare?.map((i) => i.value) : null,
                product_typ_group: selectedGroup?.length > 0 ? selectedGroup?.map((i) => i.value) : null,
                collection: selectedCollection?.length > 0 ? selectedCollection?.map((i) => i.value) : null,
                preferences: selectedPreference?.length > 0 ? selectedPreference.map((i) => i.value).join(',') : "",
              })
            );
            Swal.fire("Success!", "Product updated successfully!", "success");
          } else {
            setLoading(false);
            Swal.fire("Error!", data.errors, "Error");
          }
        })
        .catch((error) => {
          setLoading(false);
          Swal.fire("Error!", error, "error");
          console.error("Error updating product:", error);
        });
      setOpenEditModal(false);
      setProductImage("");
      setErrorMessage("");
    } catch (error) {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message,
      });
    }
  };

  const handleOpenAddModal = () => {
    setNewProduct({});
    setNewProductImage(null);
    setNewLineDiagramImage(null);
    setNewSpareData("");
    setNewGroupData("");
    setNewCollectionData("");
    setNewFinishData("");
    setNewPreferenceData("");
    setAddErrorMessage("");
    setOpenAddModal(true);
  };

  const handleCloseAddModal = () => {
    setNewProduct({});
    setOpenAddModal(false);
  };

  const handleAddChange = (event) => {
    const { name, value, files } = event.target;
    if (name === "image") {
      const file = files[0];
      const fileType = file?.type.split("/")[1]?.toLowerCase();
      if (file && (fileType === "jpeg" || fileType === "jpg")) {
        setAddErrorMessage("");
        setNewProductImage(file);
        setNewProduct((prev) => ({ ...prev, image: file }));
      } else {
        setAddErrorMessage("Please upload a valid .jpg or .jpeg image.");
      }
    } else if (name === "linediagram_image") {
      const file = files[0];
      const fileType = file?.type.split("/")[1]?.toLowerCase();
      if (file && (fileType === "jpeg" || fileType === "jpg" || fileType === "png")) {
        setAddErrorMessage("");
        setNewLineDiagramImage(file);
        setNewProduct((prev) => ({ ...prev, linediagram_image: file }));
      } else {
        setAddErrorMessage("Please upload a valid image file.");
      }
    } else {
      setNewProduct((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSaveAdd = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("sku_code", newProduct.sku_code || "");
      formData.append("brand", newProduct.brand || "");
      formData.append("mrp", newProduct.mrp || "");
      formData.append("gst", newProduct.gst || "");
      formData.append("spare_fg", newSpareData);
      formData.append("product_group", newGroupData);
      formData.append("collection", newCollectionData);
      formData.append("product_desc", newProduct.product_desc || "");
      formData.append("image", newProduct.image || "");
      formData.append("linediagram_image", newProduct.linediagram_image || "");
      formData.append("finish", newFinishData);
      formData.append("hsnCode", newProduct.hsnCode || "");
      formData.append("category", newProduct.category || "");
      formData.append("price_segment", newSegmentData || "");
      formData.append("preferences", newPreferenceData || "");

      const token = localStorage.getItem("u_token");
      fetch(`${Apiurl}admin/product/add`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "*/*",
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.message) {
            setNewProduct({});
            setLoading(false);
            dispatch(
              fetchAdminProduct({
                page: page,
                rowsPerPage: rowsPerPage,
                search: searchQuery,
                sort_by: sortBy.sort_by,
                sort_order: sortBy.order,
                brand: selectedBrand?.length > 0 ? selectedBrand?.map((i) => i.value) : null,
                finish: selectedFinish?.length > 0 ? selectedFinish?.map((i) => i.value) : null,
                spare_fg: selectedSpare?.length > 0 ? selectedSpare?.map((i) => i.value) : null,
                product_typ_group: selectedGroup?.length > 0 ? selectedGroup?.map((i) => i.value) : null,
                collection: selectedCollection?.length > 0 ? selectedCollection?.map((i) => i.value) : null,
                preferences: selectedPreference?.length > 0 ? selectedPreference.map((i) => i.value).join(',') : "",
              })
            );
            Swal.fire("Success!", "Product added successfully!", "success");
          } else {
            setLoading(false);
            Swal.fire("Error!", data.errors, "error");
          }
        })
        .catch((error) => {
          setLoading(false);
          Swal.fire("Error!", error.message, "error");
        });

      setOpenAddModal(false);
    } catch (error) {
      setLoading(false);
      Swal.fire({ icon: "error", title: "Error", text: error.message });
    }
  };

  const groupOption = group ? group.map((item) => (typeof item === 'string' ? item : (item.name || item.product_typ_group || ''))) : [];
  const segmentOption = segmentOpt ? segmentOpt.map((item) => (typeof item === 'string' ? item : (item.name || item.priceSegment || ''))) : [];
  const spareOption = spare ? spare.map((item) => (typeof item === 'string' ? item : (item.name || item.spare_fg || ''))) : [];

  const collectionOption = collection
    ? collection.map((item) => (typeof item === 'string' ? item : (item.name || item.collection || '')))
    : [];

  const collectionOpt = collection
    ? collection.map((item) => {
      const val = typeof item === 'string' ? item : (item.name || item.collection || '');
      return { value: val, label: val };
    })
    : [];
  const finishOption = finish ? finish.map((item) => (typeof item === 'string' ? item : (item.name || item.finish || ''))) : [];

  const finishOpt = finish
    ? finish.map((item) => {
      const val = typeof item === 'string' ? item : (item.name || item.finish || '');
      return { value: val, label: val };
    })
    : [];
  const groupOpt = group
    ? group.map((item) => {
      const val = typeof item === 'string' ? item : (item.name || item.product_typ_group || '');
      return { value: val, label: val };
    })
    : [];
  const spareOpt = spare
    ? spare.map((item) => {
      const val = typeof item === 'string' ? item : (item.name || item.spare_fg || '');
      return { value: val, label: val };
    })
    : [];

  const handleSelectGroup = (option) => {
    if (option) {
      setGroupData(option);
    }
  };
  const handleSelectSegment = (option) => {
    if (option) {
      setSegmentData(option);
    }
  };

  const handleSelectCollection = (option) => {
    if (option) {
      setCollectionData(option);
    }
  };
  const handleSelectSpare = (option) => {
    if (option) {
      setSpareData(option);
    }
  };
  const handleSelectFinish = (option) => {
    if (option) {
      setFinishData(option);
    }
  };

  const handleSort = (column) => {
    setSortBy((prev) => {
      if (prev.sort_by === column) {
        return {
          sort_by: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      }
      return { sort_by: column, order: "asc" };
    });
  };

  const segmentOptList = segmentOpt
    ? segmentOpt.map((item) => {
      const val = typeof item === "string" ? item : item.priceSegment || item.name || item;
      return { value: val, label: val };
    })
    : [];

  const filterConfigs = [
    { id: "brand", label: "Brand", options: brandOpt, selected: selectedBrand },
    { id: "finish", label: "Finish", options: finishOpt || [], selected: selectedFinish },
    { id: "spare", label: "Spare FG", options: spareOpt || [], selected: selectedSpare },
    { id: "group", label: "Group", options: groupOpt || [], selected: selectedGroup },
    { id: "collection", label: "Collection", options: collectionOpt || [], selected: selectedCollection },
    { id: "segment", label: "Price Segment", options: segmentOptList || [], selected: selectedSegment },
    { id: "preferences", label: "Preferences", options: preferencesOpt || [], selected: selectedPreference },

  ];

  const handleFilterChange = (filterId, nextSelected) => {
    switch (filterId) {
      case "brand": setSelectedBrand(nextSelected); break;
      case "finish": setSelectedFinish(nextSelected); break;
      case "spare": setSelectedSpare(nextSelected); break;
      case "group": setSelectedGroup(nextSelected); break;
      case "collection": setSelectedCollection(nextSelected); break;
      case "preferences": setSelectedPreference(nextSelected); break;
      case "segment": setSelectedSegment(nextSelected); break;
      default: break;
    }
    setPage(0);
  };

  const handleClearFilters = () => {
    setSearchQuery("");
    setSelectedBrand([]);
    setSelectedFinish([]);
    setSelectedSpare([]);
    setSelectedGroup([]);
    setSelectedCollection([]);
    setSelectedPreference([]);
    setSelectedSegment([]);
    setSortBy({ sort_by: "", order: "desc" });
    setPage(0);
  };


  return (
    <MainLayout title={'Products'}>

      <FilterBar2
        filters={filterConfigs}
        onFilterChange={handleFilterChange}
        searchTerm={searchQuery}
        setSearchTerm={(val) => { setSearchQuery(val); setPage(0); }}
        onClearFilters={handleClearFilters}
        actions={
          <div className="flex items-center gap-2">
            <Button
              variant="contained"
              startIcon={<TableChartIcon />}
              onClick={handleDownloadExcel}
              sx={{
                textTransform: "none",
                bgcolor: "#2e7d32",
                py: "2px",
                px: "14px",
                borderRadius: 12,
                fontSize: "12px",
                whiteSpace: "nowrap",
                "&:hover": { bgcolor: "#1b5e20" },
              }}
            >
              Excel
            </Button>

            <Button
              variant="contained"
              onClick={handleOpenAddModal}
              startIcon={<Plus />}
              sx={{
                textTransform: "none",
                bgcolor: "#1565c0",
                py: "2px",
                px: "14px",
                borderRadius: 12,
                fontSize: "12px",
                whiteSpace: "nowrap",
                "&:hover": { bgcolor: "#0d47a1" },
              }}
            >
              Add Product
            </Button>

            <BulkUploadProduct />
          </div>
        }
      />
      <Paper elevation={3} style={{}}>
        <TableContainer>
          <Table>
            <TableHead sx={{ background: "#04121f", color: "white" }}>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    whiteSpace: "nowrap",
                  }}
                >
                  SL No.
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    whiteSpace: "nowrap",
                  }}
                >
                  <TableSortLabel
                    active={sortBy.sort_by === "hsnCode"}
                    direction={
                      sortBy.sort_by === "hsnCode" ? sortBy.order : "desc"
                    }
                    onClick={() => handleSort("hsnCode")}
                    hideSortIcon={false}
                    sx={{
                      color: "white !important",
                      cursor: "pointer",
                      "& .MuiTableSortLabel-icon": {
                        opacity: 1,
                        color: "white !important",
                      },
                    }}
                  >
                    HSN Code
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    whiteSpace: "nowrap",
                  }}
                >
                  <TableSortLabel
                    active={sortBy.sort_by === "sku_code"}
                    direction={
                      sortBy.sort_by === "sku_code" ? sortBy.order : "desc"
                    }
                    onClick={() => handleSort("sku_code")}
                    hideSortIcon={false}
                    sx={{
                      color: "white !important",
                      cursor: "pointer",
                      "& .MuiTableSortLabel-icon": {
                        opacity: 1,
                        color: "white !important",
                      },
                    }}
                  >
                    SKU Code
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    whiteSpace: "nowrap",
                  }}
                >
                  <TableSortLabel
                    active={sortBy.sort_by === "brand"}
                    direction={
                      sortBy.sort_by === "brand" ? sortBy.order : "desc"
                    }
                    onClick={() => handleSort("brand")}
                    hideSortIcon={false} // <-- keep icon visible even when inactive
                    sx={{
                      color: "white !important",
                      cursor: "pointer",
                      "& .MuiTableSortLabel-icon": {
                        opacity: 1, // <-- don't fade when inactive
                        color: "white !important",
                      },
                    }}
                  >
                    Brand
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    whiteSpace: "nowrap",
                  }}
                >
                  <TableSortLabel
                    active={sortBy.sort_by === "description"}
                    direction={
                      sortBy.sort_by === "description" ? sortBy.order : "desc"
                    }
                    onClick={() => handleSort("description")}
                    hideSortIcon={false} // <-- keep icon visible even when inactive
                    sx={{
                      color: "white !important",
                      cursor: "pointer",
                      "& .MuiTableSortLabel-icon": {
                        opacity: 1, // <-- don't fade when inactive
                        color: "white !important",
                      },
                    }}
                  >
                    Product Description
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    whiteSpace: "nowrap",
                  }}
                >
                  <TableSortLabel
                    active={sortBy.sort_by === "finish"}
                    direction={
                      sortBy.sort_by === "finish" ? sortBy.order : "desc"
                    }
                    onClick={() => handleSort("finish")}
                    hideSortIcon={false} // <-- keep icon visible even when inactive
                    sx={{
                      color: "white !important",
                      cursor: "pointer",
                      "& .MuiTableSortLabel-icon": {
                        opacity: 1, // <-- don't fade when inactive
                        color: "white !important",
                      },
                    }}
                  >
                    Finish
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    whiteSpace: "nowrap",
                  }}
                >
                  <TableSortLabel
                    active={sortBy.sort_by === "mrp"}
                    direction={sortBy.sort_by === "mrp" ? sortBy.order : "desc"}
                    onClick={() => handleSort("mrp")}
                    hideSortIcon={false} // <-- keep icon visible even when inactive
                    sx={{
                      color: "white !important",
                      cursor: "pointer",
                      "& .MuiTableSortLabel-icon": {
                        opacity: 1, // <-- don't fade when inactive
                        color: "white !important",
                      },
                    }}
                  >
                    MRP
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    whiteSpace: "nowrap",
                  }}
                >
                  Image
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    whiteSpace: "nowrap",
                  }}
                >
                  Line Diagram
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    whiteSpace: "nowrap",
                  }}
                >
                  <TableSortLabel
                    active={sortBy.sort_by === "gst"}
                    direction={sortBy.sort_by === "gst" ? sortBy.order : "desc"}
                    onClick={() => handleSort("gst")}
                    hideSortIcon={false} // <-- keep icon visible even when inactive
                    sx={{
                      color: "white !important",
                      cursor: "pointer",
                      "& .MuiTableSortLabel-icon": {
                        opacity: 1, // <-- don't fade when inactive
                        color: "white !important",
                      },
                    }}
                  >
                    Gst %
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    whiteSpace: "nowrap",
                  }}
                >
                  <TableSortLabel
                    active={sortBy.sort_by === "category"}
                    direction={
                      sortBy.sort_by === "category" ? sortBy.order : "desc"
                    }
                    onClick={() => handleSort("category")}
                    hideSortIcon={false} // <-- keep icon visible even when inactive
                    sx={{
                      color: "white !important",
                      cursor: "pointer",
                      "& .MuiTableSortLabel-icon": {
                        opacity: 1, // <-- don't fade when inactive
                        color: "white !important",
                      },
                    }}
                  >
                    Category
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    whiteSpace: "nowrap",
                  }}
                >
                  <TableSortLabel
                    active={sortBy.sort_by === "price_segment"}
                    direction={
                      sortBy.sort_by === "price_segment" ? sortBy.order : "desc"
                    }
                    onClick={() => handleSort("price_segment")}
                    hideSortIcon={false} // <-- keep icon visible even when inactive
                    sx={{
                      color: "white !important",
                      cursor: "pointer",
                      "& .MuiTableSortLabel-icon": {
                        opacity: 1, // <-- don't fade when inactive
                        color: "white !important",
                      },
                    }}
                  >
                    Price Segment
                  </TableSortLabel>
                </TableCell>
                {/* <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white" }}
                >
                  Spare Fg
                </TableCell> */}
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    whiteSpace: "nowrap",
                  }}
                >
                  <TableSortLabel
                    active={sortBy.sort_by === "type_group"}
                    direction={
                      sortBy.sort_by === "type_group" ? sortBy.order : "desc"
                    }
                    onClick={() => handleSort("type_group")}
                    hideSortIcon={false} // <-- keep icon visible even when inactive
                    sx={{
                      color: "white !important",
                      cursor: "pointer",
                      "& .MuiTableSortLabel-icon": {
                        opacity: 1, // <-- don't fade when inactive
                        color: "white !important",
                      },
                    }}
                  >
                    Product Type Group
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    whiteSpace: "nowrap",
                  }}
                >
                  <TableSortLabel
                    active={sortBy.sort_by === "collection"}
                    direction={
                      sortBy.sort_by === "collection" ? sortBy.order : "desc"
                    }
                    onClick={() => handleSort("collection")}
                    hideSortIcon={false} // <-- keep icon visible even when inactive
                    sx={{
                      color: "white !important",
                      cursor: "pointer",
                      "& .MuiTableSortLabel-icon": {
                        opacity: 1, // <-- don't fade when inactive
                        color: "white !important",
                      },
                    }}
                  >
                    Collection
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    whiteSpace: "nowrap",
                  }}
                >
                  <TableSortLabel
                    active={sortBy.sort_by === "preferences"}
                    direction={
                      sortBy.sort_by === "preferences" ? sortBy.order : "desc"
                    }
                    onClick={() => handleSort("preferences")}
                    hideSortIcon={false}
                    sx={{
                      color: "white !important",
                      cursor: "pointer",
                      "& .MuiTableSortLabel-icon": {
                        opacity: 1,
                        color: "white !important",
                      },
                    }}
                  >
                    Preference
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    whiteSpace: "nowrap",
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getStatus === "pending" || loading === true ? (
                <TableBodySkeleton cols={15} rows={10} hasActions />
              ) : adminProducts?.length > 0 ? (
                adminProducts?.map((item, index) => (
                  <TableRow key={item.id}>
                    <TableCell align="center">
                      {page * rowsPerPage + index + 1}
                    </TableCell>
                    <TableCell align="center">{item.hsnCode}</TableCell>
                    <TableCell align="center">{item.sku_code}</TableCell>
                    <TableCell align="center">{item.brand}</TableCell>
                    <TableCell align="center">{item.product_desc}</TableCell>
                    <TableCell align="center">{item.finish}</TableCell>
                    <TableCell align="center">{item.mrp}</TableCell>
                    <TableCell align="center">
                      <img
                        src={getProductImageSrc(item.image, item.updated_at)}
                        alt={item.sku_code || "Product"}
                        style={{
                          width: "60px",
                          height: "60px",
                          maxWidth: "60px",
                          maxHeight: "60px",
                          objectFit: "contain",
                          margin: "auto",
                          display: "block",
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = fallbackImg;
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <img
                        src={getProductImageSrc(item.linediagram_image, item.updated_at)}
                        alt={item.sku_code || "Product"}
                        style={{
                          width: "60px",
                          height: "60px",
                          maxWidth: "60px",
                          maxHeight: "60px",
                          objectFit: "contain",
                          margin: "auto",
                          display: "block",
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = fallbackImg;
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">{item.gst}</TableCell>
                    <TableCell align="center">{item.category}</TableCell>
                    <TableCell align="center">{item.priceSegment}</TableCell>
                    {/* <TableCell align="center">{item.spare_fg}</TableCell> */}
                    <TableCell align="center">
                      {item.product_typ_group}
                    </TableCell>
                    <TableCell align="center">{item.collection}</TableCell>
                    <TableCell align="center">{item.preferences}</TableCell>
                    <TableCell>
                      <Button onClick={(e) => handleEditClick(item)}>
                        Edit
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={26} align="center">
                    No products found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            marginTop: "1rem",
          }}
          rowsPerPageOptions={[
            10,
            20,
            50,
            100,
            500,
            1000,
            2000,
            5000,
            10000,
            counts,
          ]}
          component="div"
          count={counts}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      <Dialog open={openEditModal} onClose={handleCloseEditModal} fullWidth maxWidth="md"
        PaperProps={{
          sx: { borderRadius: "12px", overflow: "hidden", boxShadow: "0 8px 40px rgba(0,0,0,0.14)" }
        }}
      >
        <DialogTitle sx={{ p: 0 }}>
          <Box sx={{ background: "linear-gradient(135deg, #04121f 0%, #0a2035 100%)", px: 3.5, py: 2.5 }}>
            <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "16px" }}>
              Edit Product
            </Typography>
            <Typography sx={{ color: "#5a8aad", fontSize: "12px", mt: 0.3 }}>
              Update product details and save changes
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ px: 3.5, py: 3, backgroundColor: "#fff" }}>
          {(() => {
            const labelSx = {
              fontSize: "12px", fontWeight: 700, color: "#3d4a6b",
              letterSpacing: "0.01em", mb: 0.6, display: "block"
            };
            const inputSx = {
              "& .MuiOutlinedInput-root": {
                borderRadius: "7px", backgroundColor: "#f8f9fc", fontSize: "13.5px",
                "& fieldset": { borderColor: "#e2e6f0", borderWidth: "1.5px" },
                "&:hover fieldset": { borderColor: "#b0bbd8" },
                "&.Mui-focused fieldset": { borderColor: "#04121f", borderWidth: "1.5px" },
                "&.Mui-focused": { backgroundColor: "#fff" },
                "&.Mui-disabled": { backgroundColor: "#f0f2f8" },
              },
            };
            const selectSx = {
              borderRadius: "7px", backgroundColor: "#f8f9fc", fontSize: "13.5px",
              "& fieldset": { borderColor: "#e2e6f0", borderWidth: "1.5px" },
              "&:hover fieldset": { borderColor: "#b0bbd8" },
              "&.Mui-focused fieldset": { borderColor: "#04121f", borderWidth: "1.5px" },
            };

            return (
              <Grid container spacing={2} sx={{ mt: 0.5 }}>
                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Brand *</Typography>
                  <TextField select fullWidth name="brand" value={editedProduct.brand || ""} onChange={handleEditChange} sx={inputSx}>
                    <MenuItem value="GROHE">GROHE</MenuItem>
                    <MenuItem value="AS">AS</MenuItem>
                  </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Finish *</Typography>
                  <MuiSelect name="finish" value={editedProduct.finish || ""} onChange={handleEditChange} fullWidth sx={selectSx}>
                    {finishOption.map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </MuiSelect>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>MRP *</Typography>
                  <TextField fullWidth name="mrp" value={editedProduct.mrp || ""} onChange={handleEditChange} sx={inputSx} />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>SKU Code *</Typography>
                  <TextField fullWidth name="sku_code" value={editedProduct.sku_code || ""} disabled sx={inputSx} />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>HSN Code</Typography>
                  <TextField fullWidth name="hsnCode" value={editedProduct.hsnCode || ""} onChange={handleEditChange} sx={inputSx} />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>GST % *</Typography>
                  <TextField fullWidth name="gst" value={editedProduct.gst || ""} onChange={handleEditChange} sx={inputSx} />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Spare FG</Typography>
                  <MuiSelect value={spareData} onChange={(e) => handleSelectSpare(e.target.value)} fullWidth sx={selectSx}>
                    {spareOption.map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </MuiSelect>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Category</Typography>
                  <TextField fullWidth name="category" value={editedProduct.category || ""} onChange={handleEditChange} sx={inputSx} />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Price Segment *</Typography>
                  <MuiSelect value={segmentData} onChange={(e) => handleSelectSegment(e.target.value)} fullWidth sx={selectSx}>
                    {segmentOption?.map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </MuiSelect>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Product Type Group</Typography>
                  <MuiSelect value={groupData} onChange={(e) => handleSelectGroup(e.target.value)} fullWidth sx={selectSx}>
                    {groupOption.map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </MuiSelect>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Collection *</Typography>
                  <MuiSelect name="collection" value={collectionData} onChange={(e) => handleSelectCollection(e.target.value)} fullWidth sx={selectSx}>
                    {collectionOption.map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </MuiSelect>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Preference</Typography>
                  <MuiSelect value={preferencesData} onChange={(e) => setPreferenceData(e.target.value)} fullWidth sx={selectSx}>
                    {preferencesOpt.map((option) => (
                      <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                    ))}
                  </MuiSelect>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Product Image</Typography>
                  <TextField fullWidth name="image" type="file" onChange={handleEditChange} sx={inputSx} />
                  {errorMessage && (
                    <Typography sx={{ color: "#d32f2f", fontSize: "11.5px", mt: 0.5 }}>{errorMessage}</Typography>
                  )}
                  {productImage && (
                    <Box sx={{ mt: 1 }}>
                      <img
                        src={getProductImageSrc(productImage, editedProduct.updated_at)}
                        alt="Product"
                        style={{ width: 72, height: 72, objectFit: "contain", borderRadius: "8px", border: "1.5px solid #e2e6f0" }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = fallbackImg;
                        }}
                      />
                    </Box>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Line Diagram</Typography>
                  <TextField
                    fullWidth
                    name="linediagram_image"
                    type="file"
                    onChange={handleEditChange}
                    sx={inputSx}
                  />
                  {linediagram_imageImage && (
                    <Box sx={{ mt: 1 }}>
                      <img
                        src={getProductImageSrc(linediagram_imageImage, editedProduct.updated_at)}
                        alt="Line Diagram"
                        style={{ width: 72, height: 72, objectFit: "contain", borderRadius: "8px", border: "1.5px solid #e2e6f0" }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = fallbackImg;
                        }}
                      />
                    </Box>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <Typography component="label" sx={labelSx}>Description *</Typography>
                  <TextField
                    fullWidth name="product_desc"
                    value={editedProduct.product_desc || ""}
                    onChange={handleEditChange}
                    multiline rows={4}
                    placeholder="Enter product description..."
                    sx={inputSx}
                  />
                </Grid>
              </Grid>
            );
          })()}
        </DialogContent>

        <DialogActions sx={{ px: 3.5, py: 2, backgroundColor: "#f8f9fc", borderTop: "1px solid #eef0f6", gap: 1 }}>
          <Button onClick={handleCloseEditModal}
            sx={{
              textTransform: "none", fontWeight: 600, color: "#6b7a99",
              border: "1.5px solid #d8dce8", borderRadius: "7px", px: 2.5,
              "&:hover": { backgroundColor: "#eef0f6" }
            }}
          >Cancel</Button>
          <Button onClick={handleSaveEdit} variant="contained"
            sx={{
              textTransform: "none", fontWeight: 600, borderRadius: "7px", px: 2.5,
              background: "linear-gradient(135deg, #04121f, #0d2d47)",
              boxShadow: "0 2px 8px rgba(4,18,31,0.35)",
              "&:hover": {
                background: "linear-gradient(135deg, #0a2035, #163d5e)",
                boxShadow: "0 4px 14px rgba(4,18,31,0.45)"
              }
            }}
          >Save Changes</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openAddModal} onClose={handleCloseAddModal} fullWidth maxWidth="md"
        PaperProps={{
          sx: { borderRadius: "12px", overflow: "hidden", boxShadow: "0 8px 40px rgba(0,0,0,0.14)" }
        }}
      >
        <DialogTitle sx={{ p: 0 }}>
          <Box sx={{ background: "linear-gradient(135deg, #04121f 0%, #0a2035 100%)", px: 3.5, py: 2.5 }}>
            <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "16px" }}>
              Add Product

            </Typography>
            <Typography sx={{ color: "#5a8aad", fontSize: "12px", mt: 0.3 }}>
              Fill in the details below to add a new product
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ px: 3.5, py: 3, backgroundColor: "#fff" }}>
          {(() => {
            const labelSx = {
              fontSize: "12px", fontWeight: 700, color: "#3d4a6b",
              letterSpacing: "0.01em", mb: 0.6, display: "block"
            };
            const inputSx = {
              "& .MuiOutlinedInput-root": {
                borderRadius: "7px", backgroundColor: "#f8f9fc", fontSize: "13.5px",
                "& fieldset": { borderColor: "#e2e6f0", borderWidth: "1.5px" },
                "&:hover fieldset": { borderColor: "#b0bbd8" },
                "&.Mui-focused fieldset": { borderColor: "#04121f", borderWidth: "1.5px" },
                "&.Mui-focused": { backgroundColor: "#fff" },
              },
            };
            const selectSx = {
              borderRadius: "7px", backgroundColor: "#f8f9fc", fontSize: "13.5px",
              "& fieldset": { borderColor: "#e2e6f0", borderWidth: "1.5px" },
              "&:hover fieldset": { borderColor: "#b0bbd8" },
              "&.Mui-focused fieldset": { borderColor: "#04121f", borderWidth: "1.5px" },
            };

            return (
              <Grid container spacing={2} sx={{ mt: 0.5 }}>
                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Brand *</Typography>
                  <TextField select fullWidth name="brand" value={newProduct.brand || ""} onChange={handleAddChange} sx={inputSx}>
                    <MenuItem value="GROHE">GROHE</MenuItem>
                    <MenuItem value="AS">AS</MenuItem>
                  </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Finish *</Typography>
                  <MuiSelect name="finish" value={newFinishData} onChange={(e) => setNewFinishData(e.target.value)} fullWidth sx={selectSx}>
                    {finishOption.map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </MuiSelect>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>MRP *</Typography>
                  <TextField fullWidth name="mrp" value={newProduct.mrp || ""} onChange={handleAddChange} sx={inputSx} placeholder="0.00" />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>SKU Code *</Typography>
                  <TextField fullWidth name="sku_code" value={newProduct.sku_code || ""} onChange={handleAddChange} sx={inputSx} placeholder="Enter SKU code" />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>HSN Code</Typography>
                  <TextField fullWidth name="hsnCode" value={newProduct.hsnCode || ""} onChange={handleAddChange} sx={inputSx} placeholder="Enter HSN code" />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>GST % *</Typography>
                  <TextField fullWidth name="gst" value={newProduct.gst || ""} onChange={handleAddChange} sx={inputSx} placeholder="18" />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Spare FG</Typography>
                  <MuiSelect value={newSpareData} onChange={(e) => setNewSpareData(e.target.value)} fullWidth sx={selectSx}>
                    {spareOption.map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </MuiSelect>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Price Segment *</Typography>
                  <MuiSelect name="segment" value={newSegmentData} onChange={(e) => setNewSegmentData(e.target.value)} fullWidth sx={selectSx}>
                    {segmentOption?.map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </MuiSelect>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Category</Typography>
                  <TextField fullWidth name="category" value={newProduct.category || ""} onChange={handleAddChange} sx={inputSx} placeholder="Enter category" />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Group</Typography>
                  <MuiSelect value={newGroupData} onChange={(e) => setNewGroupData(e.target.value)} fullWidth sx={selectSx}>
                    {groupOption.map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </MuiSelect>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Collection *</Typography>
                  <MuiSelect fullWidth name="collection" value={newCollectionData} onChange={(e) => setNewCollectionData(e.target.value)} sx={selectSx}>
                    {collectionOption.map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </MuiSelect>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Preference</Typography>
                  <MuiSelect value={newPreferenceData} onChange={(e) => setNewPreferenceData(e.target.value)} fullWidth sx={selectSx}>
                    {preferencesOpt.map((option) => (
                      <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                    ))}
                  </MuiSelect>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Product Image</Typography>
                  <TextField fullWidth name="image" type="file" onChange={handleAddChange} sx={inputSx} inputProps={{ accept: "image/jpeg, image/jpg" }} />
                  {addErrorMessage && (
                    <Typography sx={{ color: "#d32f2f", fontSize: "11.5px", mt: 0.5 }}>{addErrorMessage}</Typography>
                  )}
                  {newProductImage && (
                    <Box sx={{ mt: 1 }}>
                      <img
                        src={getProductImageSrc(newProductImage)}
                        alt="Preview"
                        style={{ width: 72, height: 72, objectFit: "contain", borderRadius: "8px", border: "1.5px solid #e2e6f0" }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = fallbackImg;
                        }}
                      />
                    </Box>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography component="label" sx={labelSx}>Line Diagram</Typography>
                  <TextField
                    fullWidth
                    name="linediagram_image"
                    type="file"
                    onChange={handleAddChange}
                    sx={inputSx}
                    inputProps={{ accept: "image/jpeg, image/jpg" }}
                  />
                  {newLineDiagramImage && (
                    <Box sx={{ mt: 1 }}>
                      <img
                        src={getProductImageSrc(newLineDiagramImage)}
                        alt="Line Diagram Preview"
                        style={{ width: 72, height: 72, objectFit: "contain", borderRadius: "8px", border: "1.5px solid #e2e6f0" }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = fallbackImg;
                        }}
                      />
                    </Box>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <Typography component="label" sx={labelSx}>Description *</Typography>
                  <TextField
                    fullWidth name="product_desc"
                    value={newProduct.product_desc || ""}
                    onChange={handleAddChange}
                    multiline rows={4}
                    placeholder="Enter product description..."
                    sx={inputSx}
                  />
                </Grid>
              </Grid>
            );
          })()}
        </DialogContent>

        <DialogActions sx={{ px: 3.5, py: 2, backgroundColor: "#f8f9fc", borderTop: "1.5px solid #eef0f6", gap: 1 }}>
          <Button onClick={handleCloseAddModal}
            sx={{
              textTransform: "none", fontWeight: 600, color: "#6b7a99",
              border: "1.5px solid #d8dce8", borderRadius: "7px", px: 2.5,
              "&:hover": { backgroundColor: "#eef0f6" }
            }}
          >Cancel</Button>
          <Button onClick={handleSaveAdd} variant="contained"
            sx={{
              textTransform: "none", fontWeight: 600, borderRadius: "7px", px: 2.5,
              background: "linear-gradient(135deg, #04121f, #0d2d47)",
              boxShadow: "0 2px 8px rgba(4,18,31,0.35)",
              "&:hover": {
                background: "linear-gradient(135deg, #0a2035, #163d5e)",
                boxShadow: "0 4px 14px rgba(4,18,31,0.45)"
              }
            }}
          >Add Product</Button>
        </DialogActions>
      </Dialog>
    </MainLayout>
  );
}

const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderColor: state.isFocused ? "#0288d1 !important" : "#c4c4c4",
    boxShadow: state.isFocused ? "0 0 0 1px #0288d1" : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#0288d1" : "#a0a0a0",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "2px 8px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  placeholder: (base) => ({
    ...base,
    color: "#a0a0a0",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};